import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Anasayfa', path: '/' },
    { name: 'One More Ürünler', path: '/onemoreurunler' },
    { name: 'Sertifikalar', path: '/sertifikalar' },
    { name: 'Hakkımızda', path: '/hakkimizda' },
    { name: 'İletişim', path: '/iletisim' },
    { name: 'SSS', path: '/sss' }
  ];

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-lg' : 'bg-white/95 backdrop-blur-sm'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex flex-col items-center space-y-1">
            <img 
              src="https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/3d1dsg1y_onemore%20logo.png" 
              alt="One More International" 
              className="h-10 w-auto object-contain"
            />
            <span className="text-[#001F3F] text-xs font-semibold text-center">
              Resmi Bağımsız Distribütör
            </span>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
                  location.pathname === link.path
                    ? 'text-[#001F3F] bg-[#001F3F]/10'
                    : 'text-gray-700 hover:text-[#001F3F] hover:bg-gray-50'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Button 
              onClick={() => window.open('https://om.run/!adxpokr', '_blank')}
              className="ml-4 bg-[#001F3F] hover:bg-[#003366] text-white px-6 py-2 rounded-lg font-medium transition-all duration-200 shadow-md hover:shadow-lg"
            >
              Kayıt Ol
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden p-2 rounded-lg text-[#001F3F] hover:bg-gray-100 transition-colors"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-white border-t border-gray-200 shadow-lg">
          <div className="px-4 py-4 space-y-2">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsOpen(false)}
                className={`block px-4 py-3 rounded-lg text-sm font-medium transition-all ${
                  location.pathname === link.path
                    ? 'text-[#001F3F] bg-[#001F3F]/10'
                    : 'text-gray-700 hover:bg-gray-50'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Button 
              onClick={() => {
                window.open('https://om.run/!adxpokr', '_blank');
                setIsOpen(false);
              }}
              className="w-full bg-[#001F3F] hover:bg-[#003366] text-white py-3 rounded-lg font-medium"
            >
              Kayıt Ol
            </Button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;